<template>
  <div>
    <div data-bs-theme="light">
      <div style="width: 100%;">
        <AgGridVue  ref="grid"
                    :class="getTheme"
                    :columnDefs="dynamicColumnDefs"
                    :defaultColDef="defaultColumnDefinitions"
                    :gridOptions="gridOptions"
                    :groupDisplayType="groupDisplayType"
                    :groupHideOpenParents="false"
                    :localeText="localeText"
                    :rowData="localRowData"
                    :sideBar="sideBar"
                    style="width: 100%;"
                    :tooltipShowDelay="tooltipShowDelay"
                    />
      </div>
    </div>
  </div>
</template>
  
<script>
  import "ag-grid-community/dist/styles/ag-grid.css";
  import "ag-grid-community/dist/styles/ag-theme-alpine.css";
  import "ag-grid-community/dist/styles/ag-theme-alpine-dark.css";
  import "ag-grid-community/dist/styles/ag-theme-balham.css";
  import "ag-grid-community/dist/styles/ag-theme-balham-dark.css";
  import "ag-grid-community/dist/styles/ag-theme-material.css";
  import { AgGridVue } from "ag-grid-vue";
  import 'ag-grid-enterprise';

  import CxTableColumns from '@/mixins/jlr/CxTableColumns';
  import MarketCellRenderer from '@/components/CX/Grid/MarketCellRenderer';

  export default {
    mixins: [ CxTableColumns ],
  
    components: { 
      AgGridVue, MarketCellRenderer 
    },
  
    props: {
      countryData:        { type: Object, default: () => {} },
      overall:            { type: Array,  default: () => [] },
    },
  
    data() {
      return {
        isMounted: false,
        gridOptions: {
          animateRows: true,
          autoGroupColumnDef: {
            headerName: this.$t('Webportal.CX.Market'),
            field: "QuestionText",
            resizable: true,
            Width: 500,
            autoHeight: true,
            cellRendererParams: {
              suppressCount: true,
            },
            cellClassRules: {
              'market-question-cell': params => { 
                return !(!params.value || params.value.length === 2 || !params.data);
              }
            }
          },
          columnDefs: this.dynamicColumnDefs,
          context: {
            countryData: this.countryData,
            getCountry: (key)  => {
              return this.countryData.Countries.find(x => x.CountryName === key);
            }, 
            getCountryById: (key)  => {
              return this.countryData.Countries.find(x => x.CountryId === key);
            }, 
            hasChildren: (key) => {
              return this.countryData.ClusterGroup.find(x => x.CountryId === key);
            },
            getTranslation: (country, cluster) => {
              const c = this.countryData.ClusterGroup.find(x => x.CountryName === country);
              const item = this.countryData.Cluster.find(x => x.CountryId === c.CountryId && x.Code === cluster);
              return (!item) ? cluster : item.Name;
            },
            onClickCountry: (countryId)  => {
              if (this.alternativeDisplay) {
                let backup = JSON.parse(JSON.stringify(this.gridColumnApi.getColumnState()));
                this.$store.commit('ColumnBackup', backup);
              }
              this.$emit("drilldownToRetailer", countryId);
            }
          },
          defaultExcelExportParams: {
            // exportAsExcelTable: true,
            showFilterButton: true

          },
          domLayout: 'autoHeight',
          groupDefaultExpanded: 0,
          onColumnVisible: (event) => {
            event.api.sizeColumnsToFit();
          },
          onGridReady: (event) => {
            event.api.sizeColumnsToFit();
            this.gridApi = event.api;
            this.gridColumnApi = event.columnApi;
          },
          getContextMenuItems: function(params) {
            return null;
          },  
        },
        defaultColumnDefinitions: { 
          flex: 1,
          minWidth: 60,
          sortable: true,
          filter: true,
          enableRowGroup: false // custom row grouping
        },
      }
    },
  
    watch: {
      countryData: {
        handler(newVal, oldVal) {
          this.refreshMarketRowData(newVal);
        }
      },
      alternativeDisplay: {
        handler(newVal, oldVal) {
          if (oldVal === true) {
            let backup = JSON.parse(JSON.stringify(this.gridColumnApi.getColumnState()));
            this.$store.commit('ColumnBackup', backup);
          }

          this.refreshMarketRowData('switch');
          this.$emit("updated:alternativeDisplay", newVal);
        }
      }
    },
  
    mounted() {
      if (this.countryData) {
        this.refreshMarketRowData(this.countryData);
      }
      this.isMounted = true;
    },
   
    methods: {
      refreshMarketRowData(values) {
        const data = values === 'switch' 
          ? this.countryData 
          : values;

        if (!data.waves) 
          return;

        let local = [];
        if (this.alternativeDisplay) {
          this.localStaticColumnDefinitions = 
            this.initMarketStaticColumnDefinitionsAlternative();

          let dynamicColumns = this.initMarketColumnsAlternative(data);
          let tree = this.flattenTree(dynamicColumns)
          tree.forEach(x => x.hide = true);
          this.restoreSettings(tree, this.$store.state.ui);
          tree.forEach(x => {
            if (x.forceVisible) x.hide = false;
          });
          this.localDynamicColumnDefinitions = dynamicColumns;

          local = [ ...data.Countries ];
        } else {
          this.localStaticColumnDefinitions = 
            this.initMarketStaticColumnDefinitions();

          this.localDynamicColumnDefinitions = 
            this.initMarketColumns(data.waves, data.Cluster, data.ClusterGroup);

          local = [
            ...this.computeMarketQuestions(data),
            ...data.Countries.filter(y => ![...new Set(data.Question.map(x => x.CountryId))].includes(y.CountryId))];
        }

        local.sort((a, b) => {
          let result = a.CountryName.localeCompare(b.CountryName,  'de', { sensitivity: 'base' });
          if (result !== 0) return result;
          result = a.Code.localeCompare(b.Code,  'de', { sensitivity: 'base' });
          if (result !== 0) return result;
          return a.QuestionText.localeCompare(b.QuestionText,  'de', { sensitivity: 'base' });
        });

        this.localRowData = local;
      }
    }
  };
</script>
  
<style>
  .market-question-cell {
    margin-left: 0px !important;
    overflow-wrap: break-word;
    word-break: break-word;
    white-space: normal;
    line-height: normal !important;
  }

  .ag-theme-alpine-dark .ag-ltr .ag-row-group-leaf-indent {
    margin-left: 0px !important;
  }

</style>

<style scoped>
  .msm-card {
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14),
      0 1px 5px 0 rgba(0, 0, 0, 0.12);
  }

  .msm-card-title {
    padding-bottom: 0px;
    padding-top: 0px;
    border-bottom: 1px solid lightgray;
    font-size: 1.25rem;
    font-weight: 500;
  }

  .card-footer {
    padding: 0px;
  }
</style>
